import { Checkbox } from "primereact/checkbox";
import React, { useContext, useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { getUserData } from "../../utils/localStorage";
import {
  getQrCodeImages2,
  printedQrCodeImages,
} from "../../services/QrCode/getQrCodeImages";
import StoreMenu from "../StoreMenu";
import ButtonLink from "../../ButtonLink";

const ViewQrCodePrint = () => {
  // const location = useLocation();
  const navigate = useNavigate();
  // const { storeCustomerId, bookingOrderId,selectedQrCodes } = location.state || {}; // Fallback to prevent undefined errors

  const [qrData, setQrData] = useState([]);
  const [storeCustomerId, setStoreCustomerId] = useState([]);
  const [bookingOrderId, setBookingOrderId] = useState([]);

  useEffect(() => {
    if (window.stateData) {
      setQrData(window.stateData.selectedQrCodes || []);
      setStoreCustomerId(window.stateData.storeCustomerId || []);
      setBookingOrderId(window.stateData.bookingOrderId || []);
    }
  }, []);

  const { storeData } = getUserData();

  const storeId = storeData.id;

  const [visible, setVisible] = useState(false);

  
  useEffect(() => {
    if(qrData) {
      window.print()
    }
  }, [qrData]); // Add dependencies here
 
  const renderQrCode = () => {
    return qrData?.map((item) => (
      <div >
        <div className="ml-8">
        </div>
        <div className="p-2 ">
          <div className="flex flex-1 justify-content-center ">
            <img src={`data:image/png;base64,${item}`} />
          </div>
        </div>
      </div>
    ));
  };

  const handleNavigateToQrCodePage = () => {
      const newWindow = window.open("/ViewQrCode", "_blank");

      if (newWindow) {
        newWindow.stateData = {
          bookingOrderId,
          storeCustomerId,
        };
      } else {
        alert("Please allow pop-ups to open the print page.");
      }
  };

  return (
    <div className="flex-1">
      <div
        className="h-3rem surface-0 sticky z-2 top-0 flex justify-content-center align-items-center"
        style={{
          "--surface-0": "#1752AA",
        }}
      >
        <div className="flex-1 flex ml-3 mr-3">
          <div className="flex-1 flex ">
            <div className="ml-3 flex justify-content-center align-items-center">
              {/* <div className="h-1rem w-1rem border-circle flex justify-content-center align-items-center">
              <i
                  className="pi pi-angle-left"
                  onClick={() => handleNavigateToQrCodePage()}
                  style={{ fontSize: "27px", cursor: "pointer", color: "#fff" }}
                ></i>
              </div> */}
            </div>
            <div className="flex-1 ml-5">
              <p className="text-white text-2xl font-bold uppercase">
                Order Tags
              </p>
            </div>
          </div>
        </div>
      </div>

      <div className="flex">
        <div className="flex-1 print-section">{renderQrCode()}</div>
        <div className="mr-4 mt-4">
          {qrData?.length > 0 && (
            <div
              onClick={() => window.print()}
            >
              <img
                src={"Icons/printer.png"}
                style={{
                  width: 65,
                  cursor: "pointer",
                }}
              />
            </div>
          )}
        </div>
      </div>
      <StoreMenu setVisible={setVisible} visible={visible} />
      <ButtonLink />
      <style>
        {`
          @media print {
            body * {
              visibility: hidden;
            }
            .print-section, .print-section * {
              visibility: visible;
            }
            .print-section {
              position: absolute;
              left: 0;
              top: 0;
              width: 100%;
              page-break-after: always;
            }
          }
        `}
      </style>
    </div>
  );
};

export default ViewQrCodePrint;
